// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9308) return "static/css/vendor.css";
	if (chunkId === 223) return "static/css/main.css";
	// return url for filenames based on template
	return undefined;
};